import React from 'react'
import { TypeAnimation } from 'react-type-animation';

function TypeWriter() {
    return (
        <TypeAnimation
            sequence={[
                "We are Passionate",
                1000,
                "We are Empathetic",
                1000,
                "We are Ziva",
                1000
            ]}
            cursor={true}
            repeat={Infinity}
            style={{  display: 'inline-block' }}
        />
    )
}

export default TypeWriter